/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSearchFragment, SearchFragment, FullSearchFragment} from '@amblique/contentful/app/contentful/fragments/search';

/**
 * Get a single Search by ID (base - scalars only)
 */
export const getBaseSearchById = gql`
  ${BaseSearchFragment}

  query GetBaseSearchById($id: String!, $locale: String!, $preview: Boolean) {
    search(id: $id, locale: $locale, preview: $preview) {
      ...BaseSearchFragment
    }
  }
`;

/**
 * Get a single Search by ID (standard - 1 level deep)
 */
export const getSearchById = gql`
  ${SearchFragment}

  query GetSearchById($id: String!, $locale: String!, $preview: Boolean) {
    search(id: $id, locale: $locale, preview: $preview) {
      ...SearchFragment
    }
  }
`;

/**
 * Get a single Search by ID (full - 2 levels deep)
 */
export const getFullSearchById = gql`
  ${FullSearchFragment}

  query GetFullSearchById($id: String!, $locale: String!, $preview: Boolean) {
    search(id: $id, locale: $locale, preview: $preview) {
      ...FullSearchFragment
    }
  }
`;

/**
 * Get all Search entries with pagination (base - scalars only)
 */
export const getBaseSearchs = gql`
  ${BaseSearchFragment}

  query GetBaseSearchs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SearchOrder]
    $where: SearchFilter
    $preview: Boolean
  ) {
    searchCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSearchFragment
      }
    }
  }
`;

/**
 * Get all Search entries with pagination (standard - 1 level deep)
 */
export const getSearchs = gql`
  ${SearchFragment}

  query GetSearchs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SearchOrder]
    $where: SearchFilter
    $preview: Boolean
  ) {
    searchCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SearchFragment
      }
    }
  }
`;

/**
 * Get all Search entries with pagination (full - 2 levels deep)
 */
export const getFullSearchs = gql`
  ${FullSearchFragment}

  query GetFullSearchs(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SearchOrder]
    $where: SearchFilter
    $preview: Boolean
  ) {
    searchCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSearchFragment
      }
    }
  }
`;
